import React from 'react'
import Input from './input'
import { customStyle, defaultStyle } from '../../constant/custom-style'
import { useProposalTypeData } from '../../hooks/proposal/use-proposal-type-data'

interface Props {
    value: string | null
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    isShowInput: boolean
    optionId: number
}

export default function OthersInput({ value, onChange, isShowInput, optionId }: Props) {
    
    const { typeOfGroup } = useProposalTypeData() 
    const showInput: boolean = isShowInput && typeOfGroup?.id === optionId
    
    return (
        <>
            {showInput && (
                <div className='ml-6 mt-2'>
                    <Input
                        type="text"
                        value={value ?? ""}
                        isCustomStyle={true}
                        customCss={`${defaultStyle} ${ !value ? '' : customStyle }`}
                        onChange={onChange}
                        required
                        placeholder='Please specify here'
                    />
                </div>
            )}
        </>
    )
}